var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopeOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.2H22.2V0H0V16.2ZM21 14.06L16.54 9.195L15.66 10.005L20.24 15.005H1.96L6.54 10.005L5.66 9.195L1.2 14.06V2.34C3.98159 5.53951 7.20977 8.32143 10.785 10.6H11.415C14.9902 8.32143 18.2184 5.53951 21 2.34V14.06ZM11.1 9.39C12.34 8.6 17.01 5.395 20.38 1.2H1.82C5.19 5.395 9.86 8.6 11.1 9.39Z",
    fill: "#666462"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeOutlined);
export default __webpack_public_path__ + "static/media/envelope-outlined.f859d26c62194da1a3d89176105cc8d1.svg";
export { ForwardRef as ReactComponent };